import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import _ from 'lodash';
import queryString from 'query-string';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get, getJson } from 'session';
import Pagination from 'modules/common/components/Pagination';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import { formatDate } from '../../../../helper';
import * as actions from '../actions';
import * as c from '../constants';
import history from '../../../../history';

const BPLSE2EReports = ({ getList, list, isLoading, pager }) => {
  const query = queryString.parse(window.location.search);
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};
  const [formData, setFormData] = useState({
    permit_type: 'Business Permit and License Application (BPLS)',
  });
  const syncFilters = (params) => {
    return history.replace({
      pathname: window.location.pathname,
      search: queryString.stringify(params),
    });
  };

  const handleDateChange =
    (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const handleChangePage = (page) => {
    getList({ ...formData, page });
    syncFilters({ ...formData, page });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    syncFilters({ ...formData, [e.target.name]: e.target.value });
  };

  const handleChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
    syncFilters({ ...formData, [key]: e ? e.value : '' });
  };

  useEffect(() => {
    getList({
      permit_type: 'Business Permit and License Application (BPLS)',
      ...queryString.parse(window.location.search),
    });
  }, []);

  const onSearch = (e) => {
    e.preventDefault();
    const args = {
      // ...(formData.payment_date_end && formData.payment_date_start ? {...formData} : {..._.omit(formData, ["payment_date_end", "payment_date_start"])}),
      // ...(formData.payment_date_end && {payment_date_end: formatDate(formData.payment_date_end)}),
      // ...(formData.payment_date_start && {payment_date_start: formatDate(formData.payment_date_start)}),
      ...(formData.date_end && formData.date_start
        ? { ...formData }
        : { ..._.omit(formData, ['date_end', 'date_start']) }),
      ...(formData.date_end && { date_end: formatDate(formData.date_end) }),
      ...(formData.date_start && {
        date_start: formatDate(formData.date_start),
      }),
      permit_type: 'Business Permit and License Application (BPLS)',
      module_type: 'BPLS',
    };
    getList(args);
  };

  const onClear = (e) => {
    e.preventDefault();
    setFormData({
      transaction_status: '',
      date_start: '',
      date_end: '',
      payment_date_start: '',
      payment_date_end: '',
      is_paid: '',
      payment_method: '',
      // module_type: '',
      q: '',
    });
    syncFilters({
      transaction_status: '',
      date_start: '',
      date_end: '',
      payment_date_start: '',
      payment_date_end: '',
      is_paid: '',
      payment_method: '',
      // module_type: '',
      q: '',
    });
    getList({ permit_type: 'Business Permit and License Application (BPLS)' });
    history.replace({ pathname: window.location.pathname });
  };

  const getReports = () => {
    const path = `${process.env.REACT_APP_WS}/api/v1/administrators/reports/transaction_histories/generate_csv`;
    const params = queryString.stringify({
      ...queryString.parse(window.location.search),
      ...formData,
      permit_type: 'Business Permit and License Application (BPLS)',
      bearer_token: token,
      email: _.get(authProfile, 'email'),
      module_type: 'BPLS',
      //  ...((!_.isEmpty(_.get(formData, "module_type")) || !_.isUndefined(_.get(formData, "module_type")) || !_.isNull(_.get(formData, "module_type"))) && {module_type: _.get(formData, "module_type")}),
    });
    return `${path}?${params}`;
  };

  // const filterTransactionType = options => {
  //   const moduleType = formData.module_type || ""
  //   if (moduleType === "T_BPLS") return options?.filter(item => item.label !== "CHANGE" && item.label !== "RETIREMENT")

  //   // moduleType === "BPLS" & "ALL"
  //   return options
  // }

  return (
    <div className="">
      <form onSubmit={onSearch}>
        <div className="row mt-2">
          <div className="col-2">
            <div className="form-group">
              <label className="label-reports">Transaction Types</label>
              <Select
                name="transaction_type"
                placeholder="Select Transaction Type"
                onChange={handleChangeSelect('transaction_type')}
                options={c.BPLS_TRANSACTION_TYPE}
                value={
                  query.transaction_type
                    ? {
                        value: query.transaction_type,
                        label: query.transaction_type,
                      }
                    : { value: '', label: 'ALL' }
                }
                // options={filterTransactionType(c.BPLS_TRANSACTION_TYPE)}
                // value={filterTransactionType(c.BPLS_TRANSACTION_TYPE)?.find(item => item.value === query.transaction_type) || { value: '', label: 'ALL' }}
              />
            </div>
          </div>
          {/* <div className="col-2">
            <label className="label-reports">Application Type</label>
            <Select
              name="module_type"
              placeholder="Select Module Type"
              onChange={handleChangeSelect('module_type')}
              options={c.BPLS_MODULE_TYPE}
              value={c.BPLS_MODULE_TYPE?.find(item => item.value === query.module_type) || { value: '', label: 'ALL' }}
            />
          </div> */}
          <div className="col-2 pr-0 " style={{ zIndex: 1 }}>
            <div className="form-group">
              <label className="label-reports">Status Options</label>
              <Select
                value={
                  query.transaction_status
                    ? {
                        value: query.transaction_status,
                        label: query.transaction_status,
                      }
                    : { value: '', label: 'ALL' }
                }
                name="transaction_status"
                placeholder="Select Status Option"
                onChange={handleChangeSelect('transaction_status')}
                options={c.STATUS_OPTIONS}
              />
            </div>
          </div>
          {/* {_.get(formData, 'transaction_status') !== 'PAID' ? ( */}
          <div className="form-input-group col-2">
            <label className="label-reports">Transaction Start Date</label>
            <DateInputPicker
              className="full-input"
              onChange={handleDateChange('date_start')}
              value={_.get(formData, 'date_start') || ''}
            />
          </div>
          {/* ) : (
          <div className="form-input-group col-2">
            <label className="label-reports">Payment Start Date</label>
            <DateInputPicker
              className="full-input"
              onChange={handleDateChange('payment_date_start')}
              value={_.get(formData, 'payment_date_start') || ''}
            />
          </div>
          )} */}
          {/* {_.get(formData, 'transaction_status') !== 'PAID' ? ( */}
          <div className="form-input-group col-2">
            <label className="label-reports">Transaction End Date</label>
            <DateInputPicker
              className="full-input"
              onChange={handleDateChange('date_end')}
              value={_.get(formData, 'date_end') || ''}
            />
          </div>
          {/* ) : (
          <div className="form-input-group col-2">
            <label className="label-reports">Payment End Date:</label>
            <DateInputPicker
              className="full-input"
              onChange={handleDateChange('payment_date_end')}
              value={_.get(formData, 'payment_date_end') || ''}
            />
          </div>
          )} */}
          <div className="col-2 px-0">
            <div className="form-group">
              <label className="label-reports">Payment Status</label>
              <Select
                value={
                  c.PAYMENT_STATUS_2.find(
                    (item) => item.value?.toString() === query.is_paid
                  ) || { value: '', label: 'ALL' }
                }
                name="is_paid"
                placeholder="Select Status Option"
                onChange={handleChangeSelect('is_paid')}
                options={c.PAYMENT_STATUS_2}
              />
            </div>
          </div>
          <div className="col-2">
            <div className="form-group">
              <label className="label-reports">Type of Payment</label>
              <Select
                value={c.TYPE_OF_PAYMENT.map((item) => ({
                  label: item,
                  value: item,
                })).find((item) => item.value === query.payment_method)}
                name="payment_method"
                placeholder="Select Type of Payment"
                onChange={handleChangeSelect('payment_method')}
                options={c.TYPE_OF_PAYMENT.map((type) => ({
                  label: type,
                  value: type,
                }))}
              />
            </div>
          </div>
          <div className="col-2 pr-0">
            <div className="form-group">
              <label className="label-reports">Keyword</label>
              <input
                className="form-control"
                name="q"
                onChange={onChange}
                value={query.q || ''}
              />
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-6 pr-0">
            <div className="form-group">
              <button
                type="submit"
                className="btn btn-primary cms-bg-color-primary cms-outline-primary mt-0"
              >
                <i className="fas fa-filter" /> &nbsp;&nbsp;Filter
              </button>
              &nbsp;
              <button
                onClick={onClear}
                type="button"
                className="btn btn-primary cms-bg-color-primary cms-outline-primary"
              >
                <i className="fas fa-times" /> &nbsp;&nbsp; Clear
              </button>
            </div>
          </div>
        </div>
      </form>
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="ml-auto">
          <div className="">
            <a
              href={getReports()}
              className="btn btn-md btn-primary cms-bg-color-primary cms-outline-primary "
              style={{ color: 'white' }}
            >
              <i className="fas fa-cloud-download-alt mr-2" />
              Download
            </a>
          </div>
        </div>
      </div>
      {isLoading ? (
        <div
          className="loading d-flex text-center justify-content-center align-items-center"
          style={{ height: '500px' }}
        >
          <div className="spinner text-center ">
            <span className="fas fa-5x fa-spin fa-spinner" />
          </div>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped table-sm table-bordered table-hover">
            <thead className="table-header">
              <tr>
                <th className="w-5">BIN</th>
                <th>BUSINESS NAME</th>
                <th>OWNER NAME</th>
                <th>E-SOA NO</th>
                <th>E-OR NO</th>
                <th>E-PERMIT NO</th>
                <th>TRANSMITTAL NO</th>
                <th>ADDRESS</th>
                <th>BRGY NO</th>
                <th>REF NO</th>
                <th>TRANSACTION STATUS</th>
                <th>AMOUNT</th>
              </tr>
            </thead>
            <tbody className="table-details">
              {list.map((item) => {
                return (
                  <tr key={item.id}>
                    <td>
                      {_.get(item, 'included.module.attributes.bin') || '---'}
                    </td>
                    <td>
                      {_.get(
                        item,
                        'included.module.attributes.business_name'
                      ) || '---'}
                    </td>
                    <td>
                      {_.get(item, 'included.module.attributes.owner_name') ||
                        '---'}
                    </td>
                    <td>
                      {_.get(item, 'included.module.attributes.e_soa_no') ||
                        '---'}
                    </td>
                    <td>
                      {_.get(item, 'included.module.attributes.e_or_no') ||
                        '---'}
                    </td>
                    <td>
                      {_.get(item, 'included.module.attributes.e_permit_no') ||
                        '---'}
                    </td>
                    <td>
                      {_.get(item, 'attributes.bpls_transmittal_no') || '---'}
                    </td>
                    <td>
                      {_.get(item, 'included.module.attributes.address') ||
                        '---'}
                    </td>
                    <td>
                      {_.get(item, 'included.module.attributes.brgy_no') ||
                        '---'}
                    </td>

                    <td>{_.get(item, 'attributes.refno') || '---'}</td>
                    <td>
                      {_.get(item, 'attributes.transaction_status') || '---'}
                    </td>
                    <td> {_.get(item, 'attributes.amount') || '0.00'}</td>
                    {/* <td>{_.get(item, 'attributes.payment_date') || '---'}</td>
                    <td>
                      {_.get(item, 'attributes.transaction_date') || '---'}
                    </td> */}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      <div className="list-pagination">
        {pager.total_pages > 1 ? (
          <div className="d-flex justify-content-center text-center align-item-center">
            <Pagination data={pager} onChange={handleChangePage} />
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

BPLSE2EReports.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  list: _.get(api, `${c.LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.LIST) > -1,
  pager: _.get(api, `${c.LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BPLSE2EReports);
